import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { kafkaKeyType } from '../../../types/KafkaKeyTypes';
interface WebSocketState {
  isConnected: boolean;
  message: { type: string, content: any } | null;
  error: string | null;
  reconnectAttempts: number;
  lastPing: number | null;
}

const initialState: WebSocketState = {
  isConnected: false,
  message: null,
  error: null,
  reconnectAttempts: 0,
  lastPing: null,
};

const webSocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    wsConnected: (state) => {
      state.isConnected = true;
      state.error = null;
      state.reconnectAttempts = 0;
    },
    wsDisconnected: (state) => {
      state.isConnected = false;
      state.lastPing = null;
    },
    wsMessage: (state, action: PayloadAction<any>) => {
      state.message = action.payload;
    },
    wsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnected = false;
    },
    wsReconnectAttempt: (state) => {
      state.reconnectAttempts += 1;
    },
    wsPing: (state) => {
      state.lastPing = Date.now();
    },
    wsReset: (state) => {
      return initialState;
    },
  },
});

export const {
  wsConnected,
  wsDisconnected,
  wsMessage,
  wsError,
  wsReconnectAttempt,
  wsPing,
  wsReset,
} = webSocketSlice.actions;

export default webSocketSlice.reducer;

